module.exports = __webpack_public_path__ + "img/guidebook6.e89fad69.png";